import Vue from 'vue';

import PrLogPlugin from '@/plugins/LogPlugin';
import PrToastPlugin from '@/plugins/ToastPlugin';
import PrSpinnerPlugin from '@/plugins/SpinnerPlugin';
import PrDialogPlugin from '@/plugins/dialog';
import PrLoaderOverlay from '@/plugins/LoadingPlugin';
import Vuetify from 'vuetify';
import theme from '@/Theme';
import VueTheMask from 'vue-the-mask';
import VueQuillEditor from 'vue-quill-editor';
import VCharts from 'v-charts';
import Loading from 'vue-loading-overlay';
import skeleton from 'tb-skeleton';
import VueClipboards from 'vue-clipboards';

// require styles VueQuillEditor
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import 'vue-loading-overlay/dist/vue-loading.css';

import 'tb-skeleton/dist/skeleton.css';

// Centraliza as definições de todos os plugins

Vue.prototype.$theme = theme;
Vue.$theme = theme;

Vue.use(PrLogPlugin);
Vue.use(Vuetify, {
  theme: theme.baseColors,
  options: {
    customProperties: true,
  },
});
Vue.use(PrToastPlugin);
Vue.use(PrSpinnerPlugin);
Vue.use(PrDialogPlugin);
Vue.use(PrLoaderOverlay);
Vue.use(VueTheMask);
Vue.use(VueQuillEditor);
Vue.use(VCharts);
Vue.use(Loading, {
  color: '#0D47A1',
});
Vue.use(skeleton);
Vue.use(VueClipboards);



// WEBPACK FOOTER //
// ./src/plugins/index.js